module.exports = __webpack_public_path__ + "static/media/BANKNIFTY_F2.05dc8c68.txt";